import React from 'react'
import HeroBgAnimation from '../HeroBgAnimation'
import { HeroContainer, HeroBg, HeroLeftContainer, Img, HeroRightContainer, HeroInnerContainer, TextLoop, Title, Span, SubTitle,SocialMediaIcons,SocialMediaIcon, ResumeButton } from './HeroStyle'
import HeroImg from '../../images/profile.jpg'
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

const HeroSection = () => {
    return (
        <div id="about" data-aos="fade-in">
            <HeroContainer>
                <HeroBg>
                    <HeroBgAnimation />
                </HeroBg>
                <HeroInnerContainer >
                    <HeroLeftContainer id="Left">
                        <Title  data-aos="fade-up-right" data-aos-duration="1500">Hi, I am <br /> {Bio.name}</Title>
                        <TextLoop data-aos="fade-right" data-aos-duration="1000">
                            I am a
                            <Span>
                                <Typewriter
                                    options={{
                                        strings: Bio.roles,
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </Span>
                        </TextLoop>
                        <SubTitle data-aos="fade-down-right" data-aos-duration="2500">{Bio.description}</SubTitle>
                        <ResumeButton  href={Bio.resume} target='display' data-aos="fade-up-left" data-aos-duration="2500">Check Resume</ResumeButton>
                    </HeroLeftContainer>

                    <HeroRightContainer id="Right"  data-aos="fade-down-left" data-aos-duration="2000">

                        <Img src={HeroImg} alt="hero-image" />
                    </HeroRightContainer>
                </HeroInnerContainer>

            </HeroContainer>
        </div>
    )
}

export default HeroSection
